import { defaultLocale, siteHandles, type Locale } from "@i18next/ui";

export interface Tag {
    id: string;
    siteId: string;
    slug: string;
    title: string;
}

export interface Type {
    label: string;
    uri?: string;
    section?: Array<string>;
}

export interface Topic {
    id: string;
    siteId: string;
    slug: string;
    title: string;
    color: string;
}

export interface Resource {
    id: string;
    siteId: number;
    slug: string;
    title: string;
    sectionHandle: string;
    ebookCategory?: string;
    typeHandle: string;
    private: boolean;
    uri: string;
    url: string;
    postDate: string;
    eventInformation: Array<{
      startTime:string;
      customTime:string;
    }>;
    hero: Array<Record<string, any>>;
    tags: Array<Tag>;
    topics: Array<Topic>;
}

export interface Data {
    entries: Array<Resource>;
    entryCount: number;
    loading?: boolean;
}

export interface ParseResource {
    id: string;
    siteId: number;
    slug: string;
    title: string;
    sectionHandle: string;
    typeHandle: string;
    uri: string;
    url: string;
    postDate: string;
    ebookCategory?: string;
    private?: boolean;
    eventInformation?: Array<{
      startTime:string;
      customTime:string;
    }>;
    tags?: Array<Tag>;
    topics?: Array<Topic>;
    type?: string;
    hero?: {
        [x: string]: any;
        image: any;
    };
}

export const parseResources = (entries: Array<Resource>):Array<ParseResource> => {
    return !entries ? [] : entries.map(({ hero, ebookCategory = undefined, ..._val }) => {
        let { children, ..._hero } = hero[0] ?? {};
        let image = children?.find((c: any) => c.__typename === "hero_heroImage_BlockType");
        switch (_val?.sectionHandle) {
            case "ebooks":
                return {
                    type: "eBook",
                    ebookCategory: ebookCategory,
                    hero: {
                        ..._hero,
                        image: image?.ebookHeroImages.find((i: any) => true),
                    },
                    ..._val,
                };
            case "events":
                  return {
                      type: "Event",
                      hero: {
                          ..._hero,
                          image: image?.eventHeroImages.find((i: any) => true),
                      },
                      ..._val,
                  };
            case "webinars":
                return {
                    type: "Webinar",
                    hero: {
                        ..._hero,
                        image: image?.webinarHeroImages.find((i: any) => true),
                    },
                    ..._val,
                };
            case "workshops":
                return {
                    type: "Workshop",
                    hero: {
                        ..._hero,
                        image: image?.workshopHeroImages.find((i: any) => true),
                    },
                    ..._val,
                };
            default:
                // Object.entries(image).map(([img, i]) => !!img.length ? img : undefined).find(i => !!i);
                return {
                    type: "Resource",
                    hero: {
                        ..._hero,
                        image: Object.entries(image).map(([img, i]) => !!img.length ? img : undefined).find(i => !!i),
                    },
                    ..._val,
                };;
        }
    });
};

export const toResourceCards = (id: string = "#resources-cards") => {
    const navHeight = document.querySelector('.navbar')?.clientHeight ?? 0;
    const formtyElement = document.querySelector(id) as HTMLElement;
    if (formtyElement)
        document.body.scrollTo({top: formtyElement.getBoundingClientRect().top + document.body.scrollTop - navHeight - 50, behavior: 'smooth'});
}

export const types:Array<Type> = [
    {"label": "View All", "section": ["ebooks", "webinars", "workshops"]},
    {"label": "Customer Stories","uri": "case-studies"},
    {"label": "eBooks","section": ["ebooks"]},
    {"label": "Webinars","section": ["webinars"]},
    {"label": "Workshops","section": ["workshops"]},
    {"label": "Blogs","uri": "blog/"},
    {"label": "Video Series","uri": "resources/videos"},
    {"label": "Events","uri": "resources/events"},
    {"label": "Analyst Reports","uri": "resources/analyst-reports"},
];

export const orders = {
    latest: "postDate DESC",
    oldest: "postDate ASC",
};

interface ParamProps {
    locale?: Locale;
    type?: Array<string>;
    topic?: string;
    sort?: string;
    excludes?: Array<string>;
    page?: number;
    limit?: number;
}

export const GetList = (param: ParamProps, success: (res: Data) => void, error: (reason: any) => void) => {
    const {locale = defaultLocale, type, topic, sort = "latest", excludes = [], page = 1, limit = 18} = param;
    const params = new URLSearchParams();
    params.set("site", siteHandles[locale]);
    !!type && type.forEach(_t => params.append("section", _t));
    !!topic && params.set("topic", topic);
    params.set("orderBy", orders[sort as keyof typeof orders]);
    if(excludes.length > 0)
        params.append("id", "not");
    excludes.forEach(id => params.append("id", id));
    params.set("page", `${page}`);
    params.set("limit", `${limit}`);
    fetch(`/resources.json?${params.toString()}`)
      .then(res => res.json())
      .then((res:Data) => {
          success(res);
          return res;
      })
      .catch(reason => {
          error(reason);
          return undefined;
    });
};